<template>
	<div>
		<headdv ></headdv>
		<div style="height:80px;"></div>
		<div class="content_dv" :style="{height:(screenHeight-80-28)+'px'}">
			<div class="content_dv_dv">
				<div class="header flex-row">
					<div></div>
					<div class="title">缓存管理</div>
					<div></div>
				</div>
				<div class="cache_arr">
					<div class="cache_li flex1" v-for="(item ,index) in cacheList" :key="index">
						<div class="cache_web_name">{{item.name}}：</div>
						<el-button type="danger" @click="tapClearFun(item.id)">清除缓存</el-button>
					</div>
					
				</div>
				
			</div>
		</div>
		<!-- 底部 -->
		<footerdv></footerdv>
		

		<!-- 删除 -->
		<el-dialog :visible.sync="delCacheStatus" width="400px" class="dialog">
			<div class="dialog-title" slot="title">清除缓存</div>
			<span>确定清除缓存?</span>
			<span slot="footer" class="dialog-footer">
				<el-button @click="delCacheStatus=false">取 消</el-button>
				<el-button type="primary" @click="delCacheFun">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>
<script>
export default {
	data() {
		return {
			screenHeight: document.documentElement.clientHeight ,// 屏幕高度
			delCacheStatus:false,  
			cacheList:[
				//0:主页,1:收藏记录,2:浏览记录,3:小说详情页,4:小说章节,5:小说章节列表,6:搜索,7:小说分类,8:排行榜主页,9:排行榜子页
				{id:-1,name:'后台管理'},
				// {id:0,name:'首页'},
				// {id:1,name:'收藏记录'},
				// {id:2,name:'浏览记录'},
				// {id:3,name:'小说详情页'},
				// {id:4,name:'小说章节'},
				// {id:5,name:'小说章节列表'},
				// {id:6,name:'搜索'},
				// {id:7,name:'小说分类'},
				// {id:7,name:'排行榜主页'},
				// {id:7,name:'排行榜子页'},
				{id:19,name:'push-npm'},
			],
			clearId:'',
		};
	},
	created() {
	},
	methods: {
		//展示删除弹窗
		tapClearFun(id){
			this.clearId = id
			this.delCacheStatus =  true
		},
		//确定清除缓存
		delCacheFun(){
			if(this.clearId == -1){
				this.$store.commit('initCacheFun')    //初始化  head标签 侧边栏 面包屑
				this.$router.push({ name: "index2" });
				return false
			}
			this.https(this.apiList.clearCache+`?type=${this.clearId}` ).then(response => {
				if (response.data.code == this.common.code) {
					this.delCacheStatus =  false
					this.tc_element(response.data.msg,response.data.code,2,"清除缓存")
				}
			})
                
		}
		  
	},
};
</script>
<style lang="scss" scoped>
.header {
	width: 100%;
	height: 60px;
	border-bottom: 1px solid #f2f2f2;
	justify-content: space-between;

	::v-deep .el-page-header__left {
		color: #aaaaaa;
	}
	::v-deep .el-page-header__left::after {
		background-color: transparent;
	}
	.title {
		font-size: 18px;
		color: #4f7da4;
	}
	.add {
		width: 60px;
		height: 36px;
		line-height: 36px;
		text-align: center;
		border-radius: 6px;
		color: #ffffff;
		background: #4f7da4;
		cursor: pointer;
	}
}
.cache_arr{
	.cache_li{
		margin-top:20px;
		.cache_web_name{
			line-height:40px;
			text-align: center;
			width:200px;
		}
	}
}



</style>